export const PROJECT_STATUSES = ['draft', 'presented', 'approved', 'lost', 'sold'] as const;

export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

export const DEFAULT_PROJECT_STATUS: ProjectStatus = 'draft';

export const DEFAULT_PROJECT_LIST_STATUSES: ProjectStatus[] = ['draft', 'presented', 'approved'];

export const DEFAULT_PROJECT_LIST_PAGE_SIZE = 12;

export type ProjectMetadata = {
  name: string;
  clientName?: string | null;
  clientEmail?: string | null;
  clientContact?: string | null;
  address?: string | null;
  responsible?: string | null;
  status: ProjectStatus;
  observations?: string | null;
  clientRequirements?: string | null;
};

export function isProjectStatus(value: unknown): value is ProjectStatus {
  return typeof value === 'string' && (PROJECT_STATUSES as readonly string[]).includes(value);
}
